import '../../Default.css'
import './Map.css'
import { FC, useContext } from "react"
import { Flex } from 'antd'
import { ResponsiveContext } from '../../context/responsive-context'

export const Map: FC = () => {
  const { isMobile, useVertical } = useContext(ResponsiveContext)
  return (
    <div className="Default-container Map-container" id="map">
      <div className={useVertical ? "Map-header-vertical" : "Map-header"} >
      <h2 style={{ marginBlock: 0 }}>Itt találsz meg:</h2>
      </div>
      <Flex className={useVertical ? "Maps-container-vertical" : "Maps-container"} vertical={isMobile} justify={"space-evenly"}>
        <div className={useVertical ? "Map-card-vertical" : "Map-card" } style={{ backgroundColor: "#C49F8E", width: isMobile ? "100%" : "50%" }}>
          <Flex className={useVertical ? "Map-field-header-vertical" : "Map-field-header" } align={"start"} vertical >
            {useVertical &&
            <div className="Place-vertical">budapesti helyszín</div>
            }
            {!useVertical &&
            <div className="Place">
            <div style={{marginBottom: -20 }}>budapesti</div>
            <div >helyszín</div>
            </div>
            }
            <div className="Address">1055 Budapest, Honvéd tér 10.</div>
          </Flex>
          <Flex className={useVertical ? "Map-field-vertical" : "Map-field"} justify={"center"}>
            <iframe className="Google-iframe" src="https://www.google.com/maps/embed/v1/place?q=budapest,+honved+ter+10&key=AIzaSyA4ae9vnIFzAsMCMBXROQnimEomcHu1YUM"></iframe>
          </Flex>
        </div>

        <div className={useVertical ? "Map-card-vertical" : "Map-card" } style={{ backgroundColor: "#5D3F2D", width: isMobile ? "100%" : "50%" }}>
          <Flex className={useVertical ? "Map-field-header-vertical" : "Map-field-header" } align={"start"} vertical >
            {useVertical &&
            <div className="Place-vertical">kecskeméti helyszín</div>
            }
            {!useVertical &&
            <div className="Place">
            <div style={{marginBottom: -20 }}>kecskeméti</div>
            <div >helyszín</div>
            </div>
            }
          <div className="Address">6000 Kecskemét, Katona József u. 14.</div>
          </Flex>
          <Flex className={useVertical ? "Map-field-vertical" : "Map-field"} justify={"center"}>
            <iframe className="Google-iframe" src="https://www.google.com/maps/embed/v1/place?q=simon+adel+style&key=AIzaSyA4ae9vnIFzAsMCMBXROQnimEomcHu1YUM"></iframe>
          </Flex>
        </div>
      </Flex>
      <Flex className={useVertical ? "Map-footer-vertical" : "Map-footer"} vertical align={'center'} justify={'start'}>
        <Flex align={'center'}>
          <img
          className={useVertical ? "Map-footer-icon-vertical" : "Map-footer-icon"}
           src="https://media-public.canva.com/3jkBE/MAD7eL3jkBE/1/t.png"
           />
          <div
          className={useVertical ? "Map-footer-text-vertical" : "Map-footer-text"}
          >
            Igény esetén házhoz kiszállást is vállalok,<br></br>csak jelezd felém, és megbeszéljük a részleteket!
          </div>
        </Flex>
      </Flex>
    </div>
  )
}
